import React, { useState, useContext, useEffect } from 'react';
import {auth} from './../firebase/firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";
import {
	doc,
	getDoc,
	setDoc
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

// Creamos el contexto;
const AuthContext = React.createContext();

// Hook para acceder al contexto
const useAuth = () => {
	return useContext(AuthContext);
}

const AuthProvider = ({children}) => {
	const [usuario, cambiarUsuario] = useState();
	
	// Creamos un state para saber cuando termina de 
	// cargar la comprobacion de onAuthStateChanged
	const [cargando, cambiarCargando] = useState(true);

	// Efecto para ejecutar la comprobacion una sola vez.
	useEffect(() => {
		// Comprobamos si hay un usuario.
		const cancelarSuscripcion =
		onAuthStateChanged(
			auth,
			async (usuario) => {
	
				if (usuario) {
	
					const ref = doc(
						db,
						"usuarios",
						usuario.uid
					);
	
					const snap =
						await getDoc(ref);
	
					// 🔥 SI NO EXISTE
					// LO CREAMOS
					if (!snap.exists()) {
	
						await setDoc(ref, {

							uid:
								usuario.uid,
						
							email:
								usuario.email || "",
						
							nombre:
								usuario.displayName || "",
						
							photoURL:
								usuario.photoURL || "",
						
							provider:
								usuario.providerData?.[0]
									?.providerId || "email",
						
							fechaCreacion:
								new Date(),
						
							lastChest: null,
						
							yutokens: 0,
						
							// ===================
							// ONBOARDING
							// ===================
						
							onboardingCompleto:
								false,
						
							examenPrincipal:
								null,
						
							carreraObjetivo:
								null,
						
							fechaNacimiento:
								null,
						
							idiomaPreferido:
								"es",
						
							comunidadEtnica:
								null,
						
							// ===================
							// PERFIL
							// ===================
						
							ciudad:
								null,
						
							colegio:
								null,
						
							grado:
								null,
						
							universidadObjetivo:
								null,
						
							// ===================
							// MEMBRESÍA
							// ===================
						
							membresiaId:
								null,
						
							// ===================
							// FUTURO
							// ===================
						
							tipoPerfil: [
								"estudiante"
							],
						
							rachaDias:
								0
						});
					}
				}
	
				console.log(
					"AUTH CHANGED",
					usuario?.uid
				);

				cambiarUsuario(usuario);
	
				cambiarCargando(false);
			}
		);
		return cancelarSuscripcion;
	}, []);

	return (
		<AuthContext.Provider value={{usuario, cargando}}>	
			{/* Solamente retornamos los elementos hijos cuando no este cargando. 
			De esta forma nos aseguramos de no cargar el resto de la app hasta que el usuario haya sido establecido.
			
			Si no hacemos esto al refrescar la pagina el componente children intenta cargar inmediatamente, 
			antes de haber comprobado que existe un usuario. */}
			{children}
		</AuthContext.Provider>
	);
}
 
export {AuthProvider, AuthContext, useAuth};